import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lcon-tfire-opcc-ms15',
  templateUrl: './lcon-tfire-opcc-ms15.component.html',
  styleUrls: ['./lcon-tfire-opcc-ms15.component.css']
})
export class LconTfireOpccMs15Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
